export enum PaymentAccountType {
  ACCOUNT = 1,
  CASHBACK_ACCOUNT = 2,
  ESCROW = 3,
  LOAN = 4,
  MEDIATOR = 5,
  INVESTMENTS = 6,
  ACCOUNTSECONDARY = 7,
}

export enum PaymentAccountStatus {
  APPROVED = 1,
  REPROVED = 2,
  PENDING_CREATE_CORE_BANK_CONFIRM = 3,
  PENDING_CREATE_CORE_BANK = 4,
  CANCELED = 5,
  CREATING_ACCOUNT = 6,
  PENDING_DATA = 7,
  INACTIVATED = 8,
  PENDING_CONTRACT_SIGN = 9,
  ERROR_TO_CREATE_CONTRACT = 10,
  SIGN_SERVICE_ERROR = 11,
  ERROR_TO_CREATE = 999,
}

export enum CnabOriginProject {
  APP = 1,
  BACKOFFICE = 2,
}
